import _ from 'lodash';
import numeral from 'numeral';

/** Util to build out with useful helper methods * */

export const formatPrice = (price) => { //eslint-disable-line
  const priceFormat = Number.isInteger(price) ? '$0,0' : '$0,0.00';
  return numeral(price, 0).format(priceFormat);
};

export const userDisplayName = (user) => {
  if (user.display_name) {
    return `${user.display_name}`;
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name[0] || ''}`;
  }
  if (user.first_name) {
    return user.first_name;
  }
  return user.email;
};
export const userFullName = (user) => {
  if (user.first_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user.email;
};

// For removing phone formating from masked form element
export const removePhoneFormat = prettyFormatNumber => prettyFormatNumber.replace(/[^\d]/g, '');

export const isValidEmailFormat = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const getInvalidEmails = (commaSeparatedEmails) => {
  // Check if comma separated list of valid emails
  const emails = commaSeparatedEmails.split(',').map(e => e.trim());
  return _.reject(emails, isValidEmailFormat);
};

export const shopifyMultipassUrlBuilder = (returnUrl, skipLogin) => {
  const returnUrlParam = encodeURIComponent(returnUrl);
  let multipassUrl = `${global.sharedEnv.USER_SERVICE_SERVER}/multipass?return_url=${returnUrlParam}`;
  if (skipLogin) {
    multipassUrl += '&skip_login=true';
  }
  return multipassUrl;
};

export const getChromeVersion = () => {
  const chrome = navigator.userAgentData && navigator.userAgentData.brands
    .find(({ brand }) => brand === 'Google Chrome');
  return chrome && Number(chrome.version);
};

export const isEdge = () => {
  // recommended way of browser detection:
  // https://learn.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance
  let edge = navigator.userAgentData && navigator.userAgentData.brands
    .find(({ brand }) => brand === 'Microsoft Edge');

  if (!edge) {
    // legacy way as a fallback in non secure connections
    edge = navigator.userAgent.match(/(Edg)([a-z]+)?\/([0-9]+)\./);
  }
  return !!edge;
};



// WEBPACK FOOTER //
// ./app/util.js